export enum ModuleNames {
  Replenishment = 'Replenishment',
  Inventory = 'Inventory',
  StoreTransfer = 'StoreTransfer',
  Analytics = 'Analytics',
  Allocations = 'Allocations',
  Purchasing = 'Purchasing',
  SpecialEvents = 'SpecialEvents',
  PlanningAssistant = 'PlanningAssistant',
  DataCenter = 'DataCenter',
  CfoPanel = 'CfoPanel',
  CeoPanel = 'CeoPanel',
  CcoPanel = 'CcoPanel',
  Liquidation = 'Liquidation',
  OtbExecution = 'OtbExecution',
  RulesEngine = 'RulesEngine',
}
